import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

// Claves y tokens del panel (Gemini, GitHub, Cloudflare, Vultr…): la lista solo trae los últimos 4 caracteres.
export function usePanelSecrets(enabled = true) {
  return useQuery({
    queryKey: ["panel-secrets"],
    queryFn: async () => (await apiClient.get("/panel-secrets")).data,
    enabled,
    retry: false,
  });
}

export function useSaveSecret() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ key, secret, label, notes }) => (await apiClient.put(`/panel-secrets/${key}`, { secret, label: label || "", notes: notes || "" })).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["panel-secrets"] }),
  });
}

export function useDeleteSecret() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (key) => (await apiClient.delete(`/panel-secrets/${key}`)).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["panel-secrets"] }),
  });
}

export function useRevealSecret() {
  return useMutation({ mutationFn: async (key) => (await apiClient.post(`/panel-secrets/${key}/reveal`)).data });
}

// Imágenes con IA (Gemini): lo gastado hoy y el tope diario (solo lo cambia el usuario desde aquí).
export function useImageBudget(enabled = true) {
  return useQuery({
    queryKey: ["image-budget"],
    queryFn: async () => (await apiClient.get("/images/budget")).data,
    enabled,
    retry: false,
  });
}

export function useSetImageBudget() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (dailyUsd) => (await apiClient.put("/images/budget", { daily_usd: dailyUsd })).data,
    onSuccess: (data) => queryClient.setQueryData(["image-budget"], data),
  });
}
